import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Main } from "@/layout/main";

export const Route = createFileRoute("/_authenticated/projects")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Main>
      <Outlet />
    </Main>
  );
}
